/**
 * Lowest-priority adapter for classifier-inferred repeated card/item roots.
 * The data marker is persisted in builder HTML and stripped from exports.
 */

import { moveSiblingPreservingEids } from '../element-insert.js';

const ITEM_SELECTOR = '[data-pb-repeat-item]';

export const genericRepeatItemAdapter = {
  kind: 'repeat-item',
  label: 'Item',
  itemSelector: ITEM_SELECTOR,
  parentSelector: null,
  reorderSelector: ITEM_SELECTOR,
  reorderSiblingSelector: ITEM_SELECTOR,
  reorderAxis: 'grid',
  historyLabel: 'Reorder item',
  toastText: 'Item reordered',
  vtPrefix: 'pb-repeat-',
  vtSelector: ITEM_SELECTOR,
  moveFn: moveSiblingPreservingEids,
  postMoveNormalize: null,
  menuActions: ['duplicate', 'delete'],
  postInsertFlow: null,
  cssPatch: null,
  reorderable: true,

  match(probe) {
    if (!probe) return null;
    if (Array.isArray(probe.chain)) {
      return probe.chain.find((entry) => entry.repeatItem) || null;
    }
    if (typeof probe.closest !== 'function') return null;
    return probe.closest(ITEM_SELECTOR);
  }
};
